export const iotOsViewSample = {
    'summary': '<div style=\'font-family:-apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Helvetica Neue, Arial, sans-serif; font-size:14px\'><div>RuleName : test_notification_rule_slack<br>Topic : bespin/caas/raw<br>Data :  [Alerting] 온도 임계치를 초과하였습니다.<br>- 온도 : 2.3<br>- 습도 : 2.6<br>- 진동 : 271</div></div>',
    'event_id': '',
    'status': 'open',
    'urgency': 'high',
    'event_time': '2022-10-04 10:58:00+09:00',
    'metric_name': '',
    'threshold': '',
    'metric_value': '',
    'resource_name': 'AC67B2EB49C4',
    'event_type': 'INFO'
};

export const iotOpsSample = {
    'summary': '<div style=\'font-family:-apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Helvetica Neue, Arial, sans-serif; font-size:14px\'><div>RuleName : test_notification_rule_slack<br>Topic : bespin/caas/raw<br>Data :  [Alerting] 온도 임계치를 초과하였습니다.<br>- 온도 : 2.3<br>- 습도 : 2.6<br>- 진동 : 271</div></div>',
    'event_id': '',
    'status': 'open',
    'urgency': 'high',
    'event_time': '2022-10-04 10:58:00+09:00',
    'metric_name': '',
    'threshold': '',
    'metric_value': '',
    'resource_name': 'AC67B2EB49C4',
    'event_type': 'INFO'
};



// WEBPACK FOOTER //
// ./src/app/views/main/integration/cstmSmry.sample/iotops.ts